import { render, staticRenderFns } from "./AttachmentTypeDialog.vue?vue&type=template&id=7d8cded4"
import script from "./AttachmentTypeDialog.vue?vue&type=script&lang=ts"
export * from "./AttachmentTypeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports